<template>
    <div v-if="isEditing" class="flex items-center">
        <UInput
            v-model="name"
            autofocus
            @keydown.enter="handleSave"
            @keydown.esc="handleClose"
        />
        <UButton label="Lagre" @click="handleSave"/>
        <UButton
            label="Avbryt"
            color="neutral"
            variant="subtle"
            @click="handleClose"
        />
    </div>
    <div v-else class="flex items-center gap-2">
        <span>{{ account.name }}</span>
        <div class="grow"/>
        <div>
            <UButton class="text-primary text-lg i-ph-pencil" @click="handleOpen"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {RichBankAccount} from '@/bank/bank.types'
import {updateBankAccount} from '@/bank/bank-account.service'
import emitter from '@/services/infrastructure/emitter'
import {BANK_ACCOUNT_UPDATED} from '@/bank/account/account.events'

const props = defineProps({
    account: {
        type: Object as () => RichBankAccount,
        required: true
    }
})

const name = ref('')
const isEditing = ref(false)

const handleOpen = () => {
    name.value = props.account.name
    isEditing.value = true
}

const handleSave = async () => {
    const updatedBank = {
        ...props.account,
        name: name.value
    }
    await updateBankAccount(updatedBank)
    emitter.emit(BANK_ACCOUNT_UPDATED)
    handleClose()
}

const handleClose = () => {
    isEditing.value = false
}
</script>

<style scoped>

</style>
